export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_47-ea869c2e0f15ed6544d6d7d78699c17e.jpg";